import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDeviceIsLaptopSmToMobile } from "../Utils";
export default function NewsCard({ newsItem }) {
  const paragraphRef = useRef(null);
  const [truncatedText, setTruncatedText] = useState("");
  const navigate = useNavigate();
  const isLaptopSmToMobile = useDeviceIsLaptopSmToMobile();

  // Function to handle truncating the text
  const truncateText = () => {
    const paragraph = paragraphRef.current;
    const lineHeight = parseInt(getComputedStyle(paragraph).lineHeight, 10);

    const maxHeight = lineHeight * (isLaptopSmToMobile ? 1 : 6); // 1 line for mobile, 6 lines for larger screens

    if (paragraph.scrollHeight > maxHeight) {
      let originalText = paragraph.textContent;
      let truncated = originalText;

      // Use React state to set the truncated text
      while (paragraph.scrollHeight > maxHeight && truncated.length > 0) {
        truncated = truncated.slice(0, -1); // Remove one character at a time
        paragraph.textContent = truncated + "...";
      }

      setTruncatedText(paragraph.textContent);
    } else {
      setTruncatedText(paragraph.textContent);
    }
  };

  useEffect(() => {
    truncateText();
  }, [isLaptopSmToMobile, newsItem.subContent]);

  return (
    <div
      onClick={() => navigate(`/news/${newsItem.title}`)}
      className="w-full flex mt-4 md:gap-6 gap-4 cursor-pointer"
    >
      {/* Image Container */}
      <div className="laptop:w-[272px] w-1/2 laptop:h-[169px] h-[97px] border bg-black rounded-md">
        <img
          src={newsItem.image}
          alt={newsItem.title}
          className="w-full h-full object-cover object-center rounded-md"
        />
      </div>

      {/* News Content */}
      <div className="laptop:flex-1 w-1/2 md:pr-4 pr-0">
        {/* News Title */}
        <h3 className="md:font-bold font-semibold font-montserrat md:leading-5 leading-4 tracking-[0.04em] laptop:text-sm text-xs text-primary-normal">
          {newsItem.title}
        </h3>

        {/* News Date */}
        <span className="font-notoSans laptopSM:text-[10px] text-[8px] leading-5 tracking-[0.04em] text-grey-normal">
          {newsItem.date}
        </span>

        {/* Truncated Content */}
        <p
          ref={paragraphRef}
          className="font-notoSans font-light md:text-[10px] text-[8px] md:leading-4 leading-3  tracking-[0.04em] text-grey-normal mt-1"
        >
          {truncatedText || newsItem.subContent}
        </p>
      </div>
    </div>
  );
}
